<template>
<div>
  <div class="loadingContainer" v-if="loadingContainer.remind">
        <div class="loadingContainer_icon">
            <i class="el-icon-loading loadingContainer_icon_loading" v-if="loadingContainer.remind === '表格渲染中。。。'" />
            <i class="el-icon-error loadingContainer_icon_error" v-else />
        </div>
        <div class="loadingContainer_remind">
            <p>{{loadingContainer.remind}}</p>
        </div>
    </div>
    <div v-else>
  <easyCruds :tableInfo="mainTable"
  @view="view"
  @exportData="exportData"
    @mainTableReload="mainTableReload">
    <!-- taskExeTimeRange -->
    <template slot="taskExeTimeRange" slot-scope="{data}">
      <el-row style="height:39px;overflow: hidden;">
        <el-col :span="7" style="margin-bottom:0;">
          <avue-select v-model="data.taskExeTimeRange_link" :dic="dicData" placeholder="请选择执行环节"></avue-select>
        </el-col>
        <el-col :span="5" style="margin-bottom:0;">
          <avue-select style="width: 90%!important" v-model="data.taskExeTimeRange_unit" :dic="[
          {label:'分钟',value:'minute'},
          {label:'小时',value:'hour'},
          {label:'天',value:'day'},
          ]" placeholder="请选择执行时间单位"></avue-select>
        </el-col>
        <el-col :span="6" style="margin-bottom:0;">
          <el-input-number :min="0" controls-position="right" style="width: 90%" v-model="data.taskExeTimeRange_time_1"></el-input-number>
            -
        </el-col>
        <el-col :span="6" style="margin-bottom:0;">
          <el-input-number :min="1"  controls-position="right" style="width: 90%" v-model="data.taskExeTimeRange_time_2"></el-input-number>
        </el-col>
      </el-row>
    </template>
    <!-- procExeTimeRange -->
    <template slot="procExeTimeRange" slot-scope="{data}">
      <el-row style="height:39px;overflow: hidden;">
        <el-col :span="5" style="margin-bottom:0;">
          <avue-select style="width: 90%!important" v-model="data.procExeTimeRange_unit" :dic="[
          {label:'分钟',value:'minute'},
          {label:'小时',value:'hour'},
          {label:'天',value:'day'},
          ]" placeholder="请选择执行时间单位"></avue-select>
        </el-col>
        <el-col :span="6" style="margin-bottom:0;">
          <el-input-number :min="0" controls-position="right" style="width: 90%" v-model="data.procExeTimeRange_time_1"></el-input-number>
            -
        </el-col>
        <el-col :span="6" style="margin-bottom:0;">
          <el-input-number :min="1"  controls-position="right" style="width: 90%" v-model="data.procExeTimeRange_time_2"></el-input-number>
        </el-col>
      </el-row>
    </template>
  </easyCruds>
    </div>
  </div>
</template>

<script>
import { tempColDealWith } from '@/workFlow/utils/selectData'
import { initParams, initFixedCondition } from '@/workFlow/utils/params'
export default {
  props: ['dicData', 'formId', 'queryMap', 'tableComment'],
  data() {
    const queryParams = initParams(this.$route.query)
    return {
      criticalPoint: 1,
      queryParams,
      // 加载容器控制器
      loadingContainer: {
        remind: '表格渲染中。。。'
      },
      // 流程key
      processDefinitionKey: '',
      // 表单ID
      // formId: '',
      // 环节加载框
      // dicData: [],
      // 动态搜索条件map
      // queryMap: null,
      // 导出条件零时存储
      fixedConditionList: [],
      formQueryModelList: [],
      mainTable: {
        buttonSetting: {
          allowAdd: false,
          allowEdit: false,
          allowView: false,
          allowDelete: false,
          left: [{
            title: '导出数据',
            type: 'primary',
            clickEvent: 'exportData'
          }]
        },
        table: {
          loading: false,
          stripe: true,
          conditionLabelWidth: 'auto',
          selection: false,
          columns: [],
          operation: {
            width: '100',
            operations: [{
              clickEvent: 'view',
              title: '查看'
            }]
          },
          tableData: [],
          paging: {
            currentPage: 1,
            pageSizes: [15, 20, 25, 30],
            pageSize: 15,
            total: 0
          },
          reload: 'mainTableReload',
          reloadConditions: {
            taskExeTimeRange_unit: 'day',
            procExeTimeRange_unit: 'day',
            ...queryParams
          }
        }
      },
      showCondition: {
        taskExeTimeRange: true,
        procExeTimeRange: true,
        procStartDateTime: true,
        ruTask: true,
        completeStatus: true
      }
    }
  },

  components: {},

  mounted: function() {
    // setTimeout(() => { // 完500毫秒秒加载第二个切换窗口
    let { processDefinitionKey, taskExeTimeRange, procExeTimeRange, procStartDateTime, ruTask, completeStatus } = this.$route.query
    if (taskExeTimeRange === 'hide') {
      this.showCondition.taskExeTimeRange = false
    }
    if (procExeTimeRange === 'hide') {
      this.showCondition.procExeTimeRange = false
    }
    if (procStartDateTime === 'hide') {
      this.showCondition.procStartDateTime = false
    }
    if (ruTask === 'hide') {
      this.showCondition.ruTask = false
    }
    if (completeStatus === 'hide') {
      this.showCondition.completeStatus = false
    }
    if (!processDefinitionKey) {
      this.$message.error('未获取到流程Key,请联系管理员')
      this.$router.push('/404')
      return
    } else {
      this.processDefinitionKey = processDefinitionKey
    }
    // this.getLinkDic()
    // this.getQueryConditionsByProcessDefinitionKey(() => {
    this.getData()
    // })
    // }, 1000)
  },
  methods: {
    view(index, row) {
      row.businessKey = row.id
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: row.businessKey,
          processInstanceId: row.processInstanceId,
          taskId: null,
          formId: null,
          pageKey: 'VIEW'
        }
      })
    },
    /**
     * 获取环节下拉列表
     */
    // getLinkDic() {
    //   this.$http.get('/flow-ext/process-task-list', {
    //     params: {
    //       procKey: this.processDefinitionKey,
    //       containHis: false
    //     }
    //   }).then(response => {
    //     this.dicData = response.data.map(item => ({ label: item.taskName, value: item.taskDefKey }))
    //   }).catch(error => {
    //     this.loadingContainer.remind = error.msg || error.message
    //     this.$message.error(error.msg || error.message)
    //   })
    // },
    /**
     * 根据流程key获取查询条件
     */
    getQueryConditionsByProcessDefinitionKey(callback) {
      this.$http.get('/business-list/query-conditions', {
        params: {
          procDefKey: this.processDefinitionKey
        }
      }).then(response => {
        this.formId = response.data.formId
        let queryMap = new Map()
        const setQueryShowType = (item) => {
          // 精确 查询
          if (item.queryType === 'accurate') {
            if (Array.isArray(item.propJson.dicData)) {
              item.showType = 'select'
            } else {
              item.showType = 'input'
            }
          } else if (item.queryType === 'blurry') {
            // 模糊
            item.showType = 'input'
          } else if (item.queryType === 'timeRange') {
            // 日期时间范围
            item.showType = 'datetimerange'
          } else if (item.queryType === 'dateRange') {
            item.showType = 'daterange'
          } else {
            item.showType = 'input'
          }
          return item
        }
        response.data.formQueryModelList.forEach(item => {
          queryMap.set(item.prop, setQueryShowType(item))
        })
        this.queryMap = queryMap
        callback()
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
        this.$message.error(error.msg || error.message)
      })
    },
    /**
     * 数据查询,顺带返回header
     */
    getData(formQueryModelList) {
      const initFixed = initFixedCondition(this.$route.query, this.queryParams)
      this.$http.post('/business-list/all-proc-complete', {
        fixedConditionList: initFixed,
        formQueryModelList: []
      }, {
        params: {
          formId: this.formId,
          pageNum: 1,
          pageSize: 15,
          procDefKey: this.processDefinitionKey
        }
      }).then(response => {
        /** 固定条件 环节执行时长 */
        this.mainTable.table.columns.push({
          prop: 'taskExeTimeRange',
          label: '环节执行时长',
          searchSlotName: 'taskExeTimeRange',
          type: 'datetimerange',
          isSearchCondition: this.showCondition.taskExeTimeRange,
          showInTable: false,
          searchSpan_xl: 12,
          searchSpan_md: 12,
          searchSpan_sm: 12,
          searchSpan_lg: 12
        })
        /** 固定条件 流程执行时长 */
        this.mainTable.table.columns.push({
          prop: 'procExeTimeRange',
          label: '流程执行时长',
          searchSlotName: 'procExeTimeRange',
          type: 'datetimerange',
          isSearchCondition: this.showCondition.procExeTimeRange,
          showInTable: false,
          searchSpan_xl: 12,
          searchSpan_md: 12,
          searchSpan_sm: 12,
          searchSpan_lg: 12
        })
        /** 流程创建时间 */
        this.mainTable.table.columns.push({
          prop: 'procStartDateTime',
          label: '创建时间',
          type: 'daterange',
          isSearchCondition: this.showCondition.procStartDateTime,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          showInTable: false,
          searchSpan_xl: window.scale > this.criticalPoint ? 8 : 6,
          searchSpan_md: window.scale > this.criticalPoint ? 8 : 6,
          searchSpan_sm: window.scale > this.criticalPoint ? 8 : 6,
          searchSpan_lg: window.scale > this.criticalPoint ? 8 : 6
        })
        /** 办结状态 */
        this.mainTable.table.columns.push({
          prop: 'completeStatus',
          label: '办结状态',
          type: 'select',
          dicData: [
            {
              label: '通过',
              value: 'success_end'
            },
            {
              label: '不通过',
              value: 'fail_end'
            },
            {
              label: '终止',
              value: 'termination'
            }
          ],
          isSearchCondition: this.showCondition.completeStatus,
          showInTable: false,
          searchSpan_xl: 6,
          searchSpan_md: 6,
          searchSpan_sm: 6,
          searchSpan_lg: 6
        })
        let colum = response.data.header.filter(item => item.isShow === 'true')
        colum.forEach(item => {
          let tempCol = {
            prop: item.prop,
            type: item.dataType,
            label: item.label,
            width: 200,
            searchSpan_xl: 6,
            searchSpan_md: 6,
            searchSpan_sm: 6,
            searchSpan_lg: 6
          }
          let queryCondition = this.queryMap.get(item.prop)
          if (queryCondition) {
            tempCol.type = queryCondition.showType
            tempCol.isSearchCondition = true
            if (queryCondition.showType === 'datetimerange') {
              tempCol.searchSpan_xl = window.scale > this.criticalPoint ? 12 : 8
              tempCol.searchSpan_md = window.scale > this.criticalPoint ? 12 : 8
              tempCol.searchSpan_sm = window.scale > this.criticalPoint ? 12 : 8
              tempCol.searchSpan_lg = window.scale > this.criticalPoint ? 12 : 8
              tempCol.format = 'yyyy-MM-dd HH:mm:ss'
              tempCol.valueFormat = 'yyyy-MM-dd HH:mm:ss'
            } else if (queryCondition.showType === 'daterange') {
              tempCol.format = 'yyyy-MM-dd'
              tempCol.valueFormat = 'yyyy-MM-dd'
            }
          }

          const columns = this.mainTable.table.columns
          return tempColDealWith({
            columns,
            propJson: item.propJson,
            tempCol
          })
        })
        this.loadingContainer.remind = ''
        // this.mainTableReload()
        this.mainTable.table.loading = false
        this.mainTable.table.tableData = response.data.businessList.records
        this.mainTable.table.paging.total = response.data.businessList.total
      }).catch(error => {
        this.loadingContainer.remind = error.msg || error.message
        this.$message.error('列表模型加载失败:' + error.msg || error.message)
      })
    },
    mainTableReload(params = { pageNum: 1, pageSize: 15 }) {
      let fixedConditionList = []
      let formQueryModelList = []
      /** procStartDateTime 创建时间  */
      if (Array.isArray(params.procStartDateTime) && params.procStartDateTime.length === 2) {
        fixedConditionList.push({
          type: 'procStartDateTime',
          rangeSeachArray: params.procStartDateTime
        })
      }
      /** 环节执行时长组装 taskExeTimeRange */
      let { taskExeTimeRange_link, taskExeTimeRange_unit, taskExeTimeRange_time_1, taskExeTimeRange_time_2 } = params
      if (taskExeTimeRange_link && taskExeTimeRange_unit && (taskExeTimeRange_time_1 === 0 || taskExeTimeRange_time_1) && taskExeTimeRange_time_2) {
        fixedConditionList.push({
          rangeSeachArray: [taskExeTimeRange_time_1, taskExeTimeRange_time_2],
          secondType: taskExeTimeRange_unit,
          type: 'taskExeTimeRange',
          value: taskExeTimeRange_link
        })
      }
      /** 流程执行时长组装 procExeTimeRange */
      let { procExeTimeRange_unit, procExeTimeRange_time_1, procExeTimeRange_time_2 } = params
      if (procExeTimeRange_unit && (procExeTimeRange_time_1 === 0 || procExeTimeRange_time_1) && procExeTimeRange_time_2) {
        fixedConditionList.push({
          rangeSeachArray: [procExeTimeRange_time_1, procExeTimeRange_time_2],
          secondType: procExeTimeRange_unit,
          type: 'procExeTimeRange'
        })
      }
      /** completeStatus 办结状态 */
      if (params.completeStatus) {
        fixedConditionList.push({
          type: 'completeStatus',
          secondType: params.completeStatus
        })
      }
      /** 其他动态搜索字段 */
      if (this.queryMap) {
        this.queryMap.forEach(function(item) {
          let value = params[item.prop]
          if ((Array.isArray(value) && value.length === 2) || value) {
            let a = Object.assign({}, item)
            if (Array.isArray(value)) {
              a.searchArray = value
            } else {
              a.searchValue = value
            }
            delete a.propJson
            formQueryModelList.push(a)
          }
        })
      }
      /**  组装 params 参数  */
      // 固定参数
      this.mainTable.table.loading = true
      this.fixedConditionList = fixedConditionList
      this.formQueryModelList = formQueryModelList
      this.$http.post('/business-list/all-proc-complete', {
        fixedConditionList,
        formQueryModelList
      }, {
        params: {
          formId: this.formId,
          pageNum: params.pageNum,
          pageSize: params.pageSize,
          procDefKey: this.processDefinitionKey
        }
      }).then(response => {
        this.mainTable.table.loading = false
        this.mainTable.table.tableData = response.data.businessList.records
        this.mainTable.table.paging.total = response.data.businessList.total
      }).catch(error => {
        this.mainTable.table.loading = false
        this.$message.error('加载数据错误:' + error.msg || error.message)
      })
    },
    exportData() {
      this.$confirm('确定要导出数据吗?', '提示', { cancelButtonText: '取消', confirmButtonText: '确定', type: 'warning' }).then(() => {
        this.$downloadFile.post('/business-list/all-proc-complete-export', {
          fixedConditionList: this.fixedConditionList,
          formQueryModelList: this.formQueryModelList
        }, {
          params: {
            formId: this.formId,
            procDefKey: this.processDefinitionKey,
            fileName: this.tableComment + '(已完成).xls',
            doDownload: true
          }
        }).then(response => {

        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
      }).catch(_ => {})
    }

  }
}

</script>
<style lang="scss" scoped>
.loadingContainer{
  width:500px;
  margin:0 auto;
  padding: 5px 0;
  color:rgb(59,156,217);
  text-align:center;
  font-weight:600;
  &_icon{
    font-size:25px;
    &_error{ color:red;}
  }
  &_remind{
    p{
      margin: 0;
      width:100%;
    }
  }
}
</style>
